import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { ColorsPalette } from '../../../config/colors'

const PremiumIcon = ({ className }) => {
  const t = useSelector(selectTranslate)

  return (
    <Tooltip title={t('common.premium_feature')}>
      <FontAwesomeIcon icon={faBadgeCheck} color={ColorsPalette.PREMIUM} className={className} />
    </Tooltip>
  )
}

export default PremiumIcon
